import { gql } from "@apollo/client";

export const getCofConfigs = gql`
    query getCofConfigs($configIds: [CofConfigId!]!) {
        getCofConfigs(input: { configIds: $configIds }) {
            configs {
                configId
                studyName
                experimentId
                namespace
                pb_delete
                priority
                sequenceId
                servePlatformsList
                value {
                    boolValue
                    floatValue
                    intPairValue
                    intValue
                    longValue
                    stringValue
                }
            }
        }
    }
`;
